// extracted by mini-css-extract-plugin
export default {"cls1":"jNWGGL_mynz6d2oUq3_A","cls2":"tYdiwKJ_RSfHGJKTdIDM jNWGGL_mynz6d2oUq3_A"};